module.exports = __webpack_public_path__ + "img/maldon.a4f5565c.jpg";